<div class="e-card">
  <ng-content select=".e-card-header"></ng-content>
  <ng-content select=".e-card-content"></ng-content>
  <ng-content select=".e-card-footer"></ng-content>
  <ng-content select=".e-card-actions"></ng-content>
</div>
